import React from 'react';

const DevTag = () => {
  return (
    <div className="dev-tag">
      Ambiente DEV
    </div>
  )
}

export default DevTag
